import first from 'lodash/first'
import { useCallback, useRef } from 'react'

import { isBodyDesktop } from '@Domains/Navigation/Features/Menu/Menu'
import { enableBodyScroll, preventBodyScroll } from '@Globals/BodyHelpers'

// useScrollToTop scrolls the list wrapper back into view on filter/page
// changes, compensating for the fixed header on mobile and a scroll-locked
// filter modal. Shared by the product-list and look-list blocks.
export function useScrollToTop() {
  const wrapperRef = useRef<HTMLDivElement | null>(null)

  const scrollToTop = useCallback(() => {
    let mobileModifier = 0
    if (typeof document !== 'undefined') {
      mobileModifier = first(document.getElementsByTagName('header'))?.clientHeight || 0
    }
    if (wrapperRef.current) {
      if (document.body.style.overflow === 'hidden') {
        enableBodyScroll()
        window.scrollTo({
          behavior: 'instant',
          top: isBodyDesktop() ? wrapperRef.current.offsetTop : wrapperRef.current.offsetTop - mobileModifier,
        })
        preventBodyScroll()
      } else if (document.scrollingElement && wrapperRef.current.offsetTop < document.scrollingElement?.scrollTop) {
        window.scrollTo({
          behavior: 'instant',
          top: isBodyDesktop() ? wrapperRef.current.offsetTop : wrapperRef.current.offsetTop - mobileModifier,
        })
      }
    }
  }, [])

  return { scrollToTop, wrapperRef }
}
